import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import { Grid } from 'antd';
import RoutesMap from 'route_control/RouteControl';
import { SessionManager, isLoggedIn } from 'utils';
const { useBreakpoint } = Grid;

// Logged in only when token + customer cookie exist and belong to the same user;
// otherwise wipe the session and send to login.
const useAuth = () => {
    if (isLoggedIn()) return true
    SessionManager.clearAll()
    return false
}

const Auth = (props) => {
    const [collapsed, setCollapsed] = useState(false)
    const [drawerOpen, setDrawerOpen] = useState(false)
    const auth = useAuth()
    const location = useLocation()

    const screens = useBreakpoint();
    const isMobileOrTablet = !screens.lg; // < 992px → treat as mobile

    // Customer portal has no role/permission API: every menu route is allowed once logged in.
    if (!auth) {
        return <Navigate to={RoutesMap?.LOGIN?.path} />
    } else if (location.pathname === '/') {
        return <Navigate to={RoutesMap?.DASHBOARD?.path} />
    } else {
        return (
            <div>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <div className={isMobileOrTablet ? 'outlet_mobile_view' : collapsed ? "outlet_collapsed" : "outlet_not_collapsed"}>
                    <Outlet />
                </div>
            </div>
        )
    }
}

export default Auth;